import { Modal, SubmitButton } from "@xola/ui-kit";
import { SecondaryButton } from "common";
import React, { PropsWithChildren } from "react";
import { SystemInfoDisplay } from "./SystemInfo";

export interface ModalDialogProps {
    title: string;
    onClose?: () => void;
    onSend: () => void;
    sending?: boolean;
    size?: "small" | "medium" | "large" | "huge";
    isOpen?: boolean;
    shouldCloseOnOutsideClick?: boolean;
    className?: string;
}

export interface FeedbackModalProps extends ModalDialogProps {
    error?: string;
}

export const ModalDialog = ({
    title,
    children,
    onClose,
    onSend,
    sending,
    ...rest
}: PropsWithChildren<ModalDialogProps>) => {
    return (
        <Modal size="large" onClose={onClose} {...rest}>
            <Modal.Header description="Let us know how we can improve Xola!">{title}</Modal.Header>
            <Modal.Body className="">{children}</Modal.Body>
            <Modal.Footer className="flex items-center justify-end">
                <SystemInfoDisplay className="mr-auto" />
                <SecondaryButton onClick={onClose}>Cancel</SecondaryButton>
                <SubmitButton disabled={sending} onClick={onSend}>
                    Send
                </SubmitButton>
            </Modal.Footer>
        </Modal>
    );
};
